import { WesService } from 'shared/services/WesService'
import type { DTT } from 'shared/types/vp/dtt'

export const deleteFavorite = async ({ favoriteId, authorizationHeader }: DTT.Mutations.WorkEntityService.DeleteMutationVariables): Promise<number> =>
  WesService.removeFavorite(favoriteId, authorizationHeader)
